<div class="ng-box" [ngClass]="{'hasError': productPack && productPack.hasError}">
  <div class="container">
    <div class="row">
      <div *ngIf="productPack.iconUrl"
        class="col-2 align-self-center justify-content-center product-image-container d-none d-sm-block">
        <div>
          <div class="text-center">
            <img class="ng-box-img product-image" [attr.src]="productPack.iconUrl"
              (click)="onProductPackIconClick(productPack)" onerror="this.style.display='none'">
          </div>
        </div>
      </div>
      <div class="col-12 col-sm align-self-center text-center text-sm-left"
       >
        <div>
          <h3 class="product-pack-name">{{ productPack.name | translate }}</h3>
          <p>
            <span class="product-pack-info product-pack-price" *ngIf="price">{{ price }}</span>
            <span class="product-pack-info product-pack-price" *ngIf="price && description"> // </span>
            <span class="product-pack-info" *ngIf="description">{{ description | translate}}</span>
            <span class="product-pack-info" *ngIf="productDescription && (price || description)"> // </span>
            <span class="product-pack-info" *ngIf="productDescription">{{ productDescription | translate }}</span>
          </p>
        </div>
      </div>
      <div
        class="col-12 col-sm-3 article-one align-self-center justify-content-center justify-content-sm-end text-right my-2 my-lg-0">
        <div *ngFor="let counter of productPack.counters; let index = index;">
          <app-up-down #upDown [counter]="counter" [countUpEnabled]="countUpEnabled"
            (counterChanged)="onCounterChanged($event)" [isLast]="(productPack.counters.length-1) === index"
            [isLocked]="productPack.isLocked" (unlockRequest)="unlockProductPack(productPack)">
          </app-up-down>
        </div>
      </div>
      <div *ngIf="productSaleDescription"
        class="col-12 col-sm-1 article-one align-self-center justify-content-center justify-content-sm-end text-right my-2 my-lg-0">
        <fa-icon class="question-icon" [icon]="faQuestionCircle" (click)="onSaleDescriptionClick()"></fa-icon>
      </div>
      <div class="col-12 d-block d-sm-none">
        <hr>
        <!-- <div class="error">{{ productPack.error }}</div> -->
      </div>
      <!-- <div class="col-2 center invert">
        <div [innerHTML]="productPack.infoHtml"></div>
      </div> -->
    </div>
  </div>
</div>
